import React, {Fragment} from 'react'
import Dropdown from '../shared/Dropdown/index'

export default ({className, sortOptions, onChange, sortDirection, sortBy, buttonText}) => {
  const currentOption = sortOptions.find(option => option.sortBy === sortBy)

  const direction = {
    asc: {
      icon: 'fa-arrow-down-short-wide',
      label: currentOption?.ascLabel || 'Lowest first',
      inverse: 'desc'
    },
    desc: {
      icon: 'fa-arrow-down-wide-short',
      label: currentOption?.descLabel || 'Highest first',
      inverse: 'asc'
    }
  }[sortDirection]

  const handleSortChange = (e, sortOption) => {
    e.preventDefault()
    onChange(sortOption)
  }

  const handleDirectionChange = e => {
    e.preventDefault()
    onChange({sortDirection: direction.inverse})
  }

  return (
    <Fragment>
      {currentOption.sortLabel ? (
        <Dropdown id='sort-by-menu' className={className}>
          <button className='button is-outlined is-small'>
            <span>
              {buttonText || 'Sort by'}: {currentOption.sortLabel}
            </span>
            <span className='icon is-small'>
              <i className='fa fa-caret-down' aria-hidden='true'></i>
            </span>
          </button>
          {sortOptions.map((sortOption, i) => (
            <a key={i} onClick={e => handleSortChange(e, sortOption)} className='dropdown-item'>
              {sortOption.sortLabel}
            </a>
          ))}
        </Dropdown>
      ) : null}

      <button className={`button is-small ${className}`} onClick={handleDirectionChange}>
        <span className='icon'>
          <i className={`fa-solid ${direction.icon}`}></i>
        </span>
        <span>{direction.label}</span>
      </button>
    </Fragment>
  )
}
